/**
 * FacilityProcessingLabel
 * 
 * Determines and displays the localized processing facility label based on
 * the provided location. Replaces legacy App.js ProcFac logic.
 */

export const FacilityProcessingLabel = ({ facility, changeWord, t }) => {
  const getFacilityKey = () => {
    switch (facility) {
      case "Los Angeles": return "processedIn.usa";
      case "Montreal": return "processedIn.canada";
      case "China": return "processedIn.china";
      case "Vietnam": return "processedIn.vietnam";
      default: return "processedIn.usa";
    }
  };

  return (
    <>
      <input
        type="radio"
        id="processing"
        name="tmd"
        value="PROCESSING"
        onChange={() => changeWord("PROCESSING")}
      />
      <label className="cr-list" htmlFor="processing">
        {t(getFacilityKey())}
      </label>
    </>
  );
};
